/* eslint-disable @typescript-eslint/no-redeclare */
export type DataExtractorSourceType =
  (typeof DataExtractorSourceType)[keyof typeof DataExtractorSourceType];
export const DataExtractorSourceType = {
  JSON_REST_API: 'JSON_REST_API',
  STAGING: 'STAGING',
} as const;
